import template from './mapLocationList.html';
import controller from './mapLocationList.controller';
import './mapLocationList.scss';

let mapLocationListComponent = {
  restrict: 'E',
  bindings: {
    locations: '<',
    filters: '<'
  },
  template,
  controller
};

export default mapLocationListComponent;
